import astronautpng from "./astronaut.png"
import { Sprite } from "pixi.js"

export class Astronaut {
  constructor() {
    this.astronaut = Sprite.from(astronautpng)
    this.astronaut.y = -50
    this.astronaut.x = 0
    this.astronaut.scale.x = 0
    this.astronaut.scale.y = 0
    this.astronaut.anchor.set(0.5, 0.5)
    this.astronaut.alpha = 1
    // this.station.scale.set(0.5)
  }

  astronautFallAnimation = (ticker, stage) => {
    stage.addChild(this.astronaut)
    setTimeout(() => {
      ticker.add(fall)
    }, 100)
    let fallFromRight = Math.random() < 0.5
    // this.station.x = window.innerWidth / 2
    let astronaut = this.astronaut
    function fall() {
      // if (station.x < 100) {
      fallFromRight ? (astronaut.x += 5) : (astronaut.x -= 5)
      fallFromRight
        ? (astronaut.rotation += 0.06)
        : (astronaut.rotation -= 0.06)
      astronaut.y += 5
      astronaut.scale.x += 0.004
      astronaut.scale.y += 0.004
      astronaut.alpha -= 0.01
    }
    setTimeout(() => {
      stage.removeChild(this.astronaut)
      ticker.remove(fall)
    }, 2000)
  }
}
